// extracted by mini-css-extract-plugin
export default {"featured":"FeaturedSection_featured__ndSjO"};